/**
 * SCRIPT INJECTION FOR LOYALTY PAGES
 *
 * Poligon Central location:
 * "System" -> Script Injection
 */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'loyaltyScriptInjection',
  initialState: null as null | string,
  reducers: {
    setLoyaltyScriptInjection(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setLoyaltyScriptInjection } = slice.actions;

export default slice.reducer;
